<template>
  <div class="more-news block color-default">
    <h3 class="block-title"><span>{{ getCategory($route.params.category, $route.params.categoryValue).name }}</span></h3>
    <articles-query :category="{ name: $route.params.category, value: $route.params.categoryValue }">
      <template slot-scope="props">
        <div v-for="article in props.articles">
          <div class="item">
            <div class="post-block-style post-float-half clearfix">
              <div class="post-thumb" v-if="article.featured_img">
                <router-link :to="{ name: 'ArticlePage', params: { slug: article.slug, id: article.oid } }">
                  <img class="img-responsive" :src="article.featured_img" />
                </router-link>
              </div>
              <a class="post-cat" href="#" v-if="article.featured_img">
                {{ getCategory($route.params.category, $route.params.categoryValue).name }}
              </a>
              <div class="post-content">
                <h2 class="post-title">
                  <router-link :to="{ name: 'ArticlePage', params: { slug: article.slug, id: article.oid } }">
                    {{ article.title }}
                  </router-link>
                </h2>
                <div class="post-meta">
                  <span class="post-date">{{ article.date }}</span>
                </div>
                <p>{{ article.short_description }}</p>
              </div><!-- Post content end -->
            </div><!-- Post Block style 1 end -->
            <div class="gap-30"></div>
          </div>
        </div>
      </template>
    </articles-query>
    <br/><br/>
    <read-more/>
  </div>
</template>

<script>
  import { ArticlesQuery, categories } from 'itrnews-vuejs-api';
  import website from '../mixins/website';
  import ReadMore from './ReadMore';

  export default {
    name: 'ArticlesForCategory',
    components: { ReadMore, ArticlesQuery },
    mixins: [categories, website],
  };
</script>



// WEBPACK FOOTER //
// src/components/ArticlesForCategory.vue